import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { loadSingleTrainingPeriod, updateTrainingPeriod } from "../../actions/trainingPeriodActions";
import { RootState, AppDispatch  } from "../../store/configureStore";
import TrainingPeriodForm from "./TrainingPeriodForm";
import TrainingPeriod from "../../types/TrainingPeriod";

const EditTrainingPeriod: React.FC = () => {
  const { periodId } = useParams<{ periodId: string }>();
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();

  // Select training period and loading state from Redux store
  const trainingPeriodData = useSelector((state: RootState) => state.trainingPeriods.selectedTrainingPeriod, 
      (prev, next) => {console.log("trainingPeriodData new:" + JSON.stringify(next));return JSON.stringify(prev) === JSON.stringify(next)});
  const isLoading = useSelector((state: RootState) => state.trainingPeriods.loading,
                                () => false // Always return false to force re-render
                                );

  const [localTrainingPeriod, setLocalTrainingPeriod] = useState<TrainingPeriod | null>(null);

  const [localIsLoading, setLocalIsLoading] = useState<Boolean | null>(null);

  useEffect(() => {
    if (trainingPeriodData) {
      setLocalTrainingPeriod(trainingPeriodData); // Update local state
    }
  }, [trainingPeriodData]); // Trigger update when Redux data changes
  

  useEffect(() => {
    if (localIsLoading) {
      setLocalIsLoading(isLoading);
    }
  }, [isLoading])


  useEffect(() => {
    if (periodId) {
      dispatch(loadSingleTrainingPeriod(Number(periodId)));
    }
  }, [dispatch, periodId]);

  const updateTrainingPeriodToDB = async (trainingPeriodToSave: TrainingPeriod) => {
    try {
      await dispatch(updateTrainingPeriod(trainingPeriodToSave) as any); // Redux action
      navigate("/training-periods"); // Redirect to the list
    } catch (error) {
      console.error("Error updating training period:", error);
    }
  };

  const handleCancel = () => {
    navigate("/training-periods"); // Redirect back without saving
  };

  if (isLoading) {
    return <p>Loading...</p>;
  }

  if (!localTrainingPeriod) {
    return <p>No training period found.</p>;
  }

  return (
    <TrainingPeriodForm
      trainingPeriod={localTrainingPeriod}
      onSave={updateTrainingPeriodToDB}
      onCancel={handleCancel}
    />
  );
};

export default EditTrainingPeriod;
